import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import {AppConfigService} from "./app-config.service";
import { OAuthService } from 'angular-oauth2-oidc';
import { FetchInterceptorService } from './fetch-edc.interceptor';
import { AuthSessionService } from './auth/auth-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private titleService: Title,
    private configService: AppConfigService,
    private activatedRoute: ActivatedRoute,
    private oauthService: OAuthService,
    private fetchInterceptor: FetchInterceptorService,
    private authSession: AuthSessionService) {
      fetchInterceptor.initFetchInterceptor();
      authSession.init();
  }

  async ngOnInit(): Promise<void> {
    if (this.configService.isOAuthConfigured()) {
      this.oauthService.configure(this.configService.getOAuthConfig()!);
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();

      if (this.oauthService.hasValidAccessToken()) {
        const returnUrl = sessionStorage.getItem('auth_return_url');
        if (returnUrl) {
          sessionStorage.removeItem('auth_return_url');
          await this.router.navigateByUrl(returnUrl);
        }
      }
    }

    const appTitle = this.titleService.getTitle();
    const resolveTitle = (): string => {
      let child = this.activatedRoute.firstChild;
      while (child?.firstChild) {
        child = child.firstChild;
      }
      return child?.snapshot.data['title'] ?? appTitle;
    };

    this.router
      .events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => resolveTitle())
      ).subscribe((title: string) => {
        this.titleService.setTitle(title);
    });

    // Apply the title for the route that is already active (initial load /
    // post-login redirect), since that NavigationEnd fires before we subscribe.
    this.titleService.setTitle(resolveTitle());
  }

  themeClass(): string | undefined {
    return this.configService.getConfig()?.theme;
  }
}
